import { centsToDollars, formatNumberToUsd } from '@common/neo.tax';
import { colors, Stack, Typography } from '@ui-components/neo.tax';
import React from 'react';

interface CreditCalculationEstimateSectionProps {
  title: string;
  amountCents: number | undefined;
  backgroundColor: string;
  suffix?: React.ReactNode;
}

export const CreditCalculationEstimateSection = ({
  amountCents,
  backgroundColor,
  suffix,
  title,
}: CreditCalculationEstimateSectionProps): React.ReactElement => {
  const amountDollarsText = amountCents ? formatNumberToUsd(Math.round(centsToDollars(amountCents))) : '--';
  return (
    <Stack
      paddingX={4}
      paddingY={4}
      alignItems="start"
      justifyContent="center"
      direction="column"
      gap={1}
      backgroundColor={backgroundColor}
      borderRadius="lg"
      boxShadow="base"
    >
      <Typography as="p" fontFamily="sans" fontWeight="medium" fontSize="base" color={colors.gray[800]}>
        {title}
      </Typography>
      <Stack direction="row" alignItems="center" justifyContent="space-between" fullWidth>
        <Typography as="p" fontFamily="sans" fontWeight="medium" fontSize="base" color={colors.gray[800]}>
          {amountDollarsText}
        </Typography>
        {suffix}
      </Stack>
    </Stack>
  );
};
